import { OrganisationFieldsFragment, useGetOrganisationQuery } from '../../../../../generated/core-api/graphql-react-query';

export default function useAsrSettings(): OrganisationFieldsFragment {
  const org = useGetOrganisationQuery();

  if (!org.data) {
    return {
      enableCoreAsrApi: false,
      enableAlternativeAsrApi: false,
    };
  }

  if (!org.data.org.enableAlternativeAsrApi && !org.data.org.enableCoreAsrApi) {
    return {
      enableCoreAsrApi: true,
      enableAlternativeAsrApi: false,
    };
  }

  return org.data.org;
}
